import { GithubImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={GithubImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
